<template>
    <!-- 导航栏 -->
    <nav >
        <div class="header-top">
            <ul>
                <li class="logo"> 
                    <!-- <img src="http://47.94.58.162/rotech-xyjq-admin/res/v2/images/logo.png" alt="图片不存在"> -->
                </li>          
                <li class="title">
                    <p><span style='color: #ccad72;'>&nbsp;产&nbsp;融&nbsp;数&nbsp;科&nbsp;</span>金&nbsp;融&nbsp;服&nbsp;务&nbsp;平&nbsp;台</p>
                </li>
                <li class="login">
                    <a :href='login'>登录</a>
                </li>
            </ul>
        </div>
    </nav>
</template>


<script>
import config from '../../../config/ipConfig'
export default{
    name:"Navigation",
    data(){
        return {
            login : config.loginUrl,
        }
    }
}
</script>



<style scoped>
@font-face {
    font-family: '得意黑';
    src: url('../../assets/font/SmileySans-Oblique-2.ttf');
    font-weight: normal;
    font-style: normal;
}
    /* 导航栏 */
.header-top {
    width: 1920px;
    height: 60px;
    background: rgba(72, 76, 98, 0.6);
    /* float: left; */
    overflow: hidden;
    position: absolute;
    z-index: 1;
    
}

.header-top .logo{
    width: 100px;
    height: 60px;
    margin-left: 360px;
    float: left;
    line-height: 60px;
}
.header-top .logo img {
    width: 130px;
    height: 38px;

}
.header-top .title{
    width: 300px;
    height: 60px;
    /* margin-left: 20px; */
    float: left;
}

/* .header-top  .title span {
    font-family: '得意黑';
    text-align: left;
    line-height: 60px;
    font-size: 22px;
    color: #fff;
    display: block;
} */
.header-top  .title p {
    font-family: '得意黑';
    text-align: left;
    line-height: 60px;
    font-size: 22px;
    color: #fff;
    display: block;
}

.header-top .login {
    width: 150px;
    height: 60px;
    margin-right: 440px;
    background: #ccad72;
    float: right;


}

.header-top .loginSuccess {
    width: 300px;
    height: 60px;
    margin-right: 400px;
    line-height: 60px;
    color: #fff;
    float: right;
}

.header-top .loginSuccess a{
    padding-left: 30px;
    color: skyblue;
}
.header-top .loginSuccess a:hover{
    color: red;
}

.header-top .login a {
    text-decoration: none;
    width: 150px;
    /*height: 70px;*/
    height: 60px;
    text-align: center;
    /*line-height: 70px;*/
    line-height: 60px;
    font-size: 20px;
    color: white;
    display: block;
}

.header-top .login a:hover {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/Navigation.vue